var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#1d3c34;}.cls-1{stroke:#1d3c34;stroke-miterlimit:10;stroke-width:10px;}.cls-2{fill:#b7dc8f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 219,
    cy: 219,
    r: 214
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 219,
    cy: 219,
    r: 192.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.16 154.46 112.16 154.46 121.21 112.21 177.04 112.21 173.16 154.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "249.43 154.69 188.4 154.69 190.99 112.41 246.84 112.41 249.43 154.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "325.77 154.92 264.71 154.92 260.82 112.6 316.7 112.6 325.77 154.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "167.11 220.3 98.04 220.3 109.52 166.75 172.03 166.75 167.11 220.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "253.47 220.59 184.36 220.59 187.65 166.99 250.19 166.99 253.47 220.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "339.92 220.89 270.77 220.89 265.84 167.24 328.42 167.24 339.92 220.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "159.22 306.2 79.63 306.2 94.65 236.11 165.66 236.11 159.22 306.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "258.74 306.6 179.09 306.6 183.39 236.43 254.44 236.43 258.74 306.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "358.37 306.99 278.68 306.99 272.23 236.74 343.31 236.74 358.37 306.99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e1c5624f179fa4edb841ce64f28bc29.svg";
export { ForwardRef as ReactComponent };